
export enum AssetPartPosition {
  Rear= 'Rear',
  Central= 'Central',
  Frontal= 'Frontal',

}